import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  // Na home, rola até a seção; fora dela, o Link leva à home e a home rola pelo hash.
  const handleSectionClick = (e, sectionId) => {
    if (window.location.pathname !== '/') return;
    e.preventDefault();
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    window.history.replaceState(null, '', `/#${sectionId}`);
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <img src="/logo-deitada.png" alt="Navarro & Vieira Advogados" className="footer-logo" loading="lazy" />
          <p>
            Sociedade de advogados · OAB/PR 15.538
            <br />
            Rua Bélgica, nº 437, Centro, Cambé/PR · CEP 86181-090
          </p>
        </div>
        <nav className="footer-nav" aria-label="Rodapé">
          <Link to="/#areas-atuacao" onClick={(e) => handleSectionClick(e, 'areas-atuacao')}>Áreas de atuação</Link>
          <Link to="/#sobre-nos" onClick={(e) => handleSectionClick(e, 'sobre-nos')}>O escritório</Link>
          <Link to="/#advogados" onClick={(e) => handleSectionClick(e, 'advogados')}>Equipe</Link>
          <Link to="/guias">Guias</Link>
          <Link to="/noticias">Notícias</Link>
          <Link to="/#contato" onClick={(e) => handleSectionClick(e, 'contato')}>Contato</Link>
          <Link to="/golpe-do-falso-advogado">Golpe do falso advogado</Link>
          <Link to="/politica-privacidade">Política de privacidade</Link>
          <Link to="/termos-de-uso">Termos de uso</Link>
        </nav>
      </div>
      <div className="footer-bottom">
        © {new Date().getFullYear()} Navarro & Vieira Advogados. Todos os direitos reservados.
      </div>
    </footer>
  );
};

export default Footer;
